(function() {
    'use strict';
    angular
        .module('abcQualityMatchApp')
        .factory('QuestionnaireGroup', QuestionnaireGroup);

    QuestionnaireGroup.$inject = ['$resource'];

    function QuestionnaireGroup ($resource) {
        var resourceUrl =  'api/questionnaire-groups/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
